import Log from "@/utils/Log";
import Events from "@/utils/Events";
import Apm from "@/utils/Apm";

interface SendEventObject {
   [key: string]: any;
}

interface TagManagerEvent {
   sendList: ((() => boolean))[];
   submit: (oferta: any, user: any, payment: any) => void;
   push: (gtm: string, sendEventObject: SendEventObject) => void;
}

const gtm_id = "GTM-NR2VZP3";

const TagManagerEvents: TagManagerEvent = {
    sendList: [],

    submit:(offer: any = undefined, user: any = undefined, payment: any = undefined) => {

        const valor = offer?.is_escadinha ? offer?.valor?.original : offer?.valor?.valor;
        const gtm_payment = (() => {
            switch (payment?.forma){
                case 'cc':
                    return "cartaocredito"
                case 'dc':
                    return "cartaodebito"
                case 'paypal':
                    return "paypal"
            }

            return null;
        })();

        TagManagerEvents.push(gtm_id,{'event':'payment_checkout_completed'});

        TagManagerEvents.push(gtm_id,{
            event: "forcePvPurchase",
            page: "/success",
            ecommerce: {
                purchase:{
                    actionField: {
                        id: payment.idPedido ? payment.idPedido : 'cc' + Math.random()*10000000000000000,
                        affiliation: '',
                        revenue: valor,
                        tax: '',
                        shipping: '',
                        coupon: ''
                    },
                    products: offer.name
                },
                paymentMethod: gtm_payment,
                shippingMethod: '',
                userType: typeof user?.documento === "string" && user.documento.toLowerCase() === "cnpj" ? "PJ" : "PF",
                fullPrice: valor
            }
        });

    },

    push: (gtm: string, sendEventObject: SendEventObject) => {
        let event = () => {
            try{
                sendEventObject?.event && Events.trigger("GTM_"+sendEventObject.event, sendEventObject)

                //@ts-ignore
                if(typeof window.google_tag_manager === "object" && window.google_tag_manager.hasOwnProperty(gtm)){
                    //@ts-ignore
                    let dataLayerName = window?.google_tag_manager?.[gtm]?.dataLayer?.name;
                    if(window.hasOwnProperty(dataLayerName)){
                        //@ts-ignore
                        window[dataLayerName].push(sendEventObject);

                        return true;
                    }else{
                        Apm.addLabels({
                            error_gtm: `DataLayer "${dataLayerName}_${sendEventObject?.event}" not found!`
                        })
                    }
                }else{
                    Apm.addLabels({
                        error_gtm: `Tag "${gtm}_${sendEventObject?.event}" not found!`
                    })
                }
            }catch (e){
                (e instanceof Error) && Apm.captureError(e);
                console.error(e);
            }

            return false;
        };

        if(!event()){
            Log.warn("Evento não disparado", sendEventObject)
            TagManagerEvents.sendList.push(event);
        }
    }
};

let sendEvent = () => {
    for(let i in TagManagerEvents.sendList){
        if(typeof TagManagerEvents.sendList[i] === "function" && TagManagerEvents.sendList[i]()){
            TagManagerEvents.sendList.splice(+i, 1);
        }
    }
};

setInterval(() => {
    try{
        sendEvent();
    }catch(e){
        Apm.captureError("ERRO NO TagManager.ts linha 113")
    }
},300);

export default TagManagerEvents;